import React, { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';

import ResponsiveAppBar from './NavBar';
import LeftDrawer from './LeftDrawer';

// Layout persistente das telas autenticadas: AppBar fixo no topo + drawer
// lateral (permanente em desktop, hamburger + drawer temporário em mobile)
// + área principal (Outlet). Aplicado via nested routes.
//
// Também age como guard: se não houver token no storage, redireciona
// pra /. Isso protege TODAS as rotas filhas (incluindo o catch-all
// de 404) — user deslogado nunca vê header/drawer envolvendo nada.
export default function MainLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleMobileOpen = () => setMobileOpen(true);
  const handleMobileClose = () => setMobileOpen(false);

  const token = localStorage.getItem('token');
  if (!token) {
    // `state` guarda onde o user tentava ir — SignIn pode usar isso
    // depois pra redirecionar de volta após login (não implementado
    // ainda mas o hook fica pronto).
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <ResponsiveAppBar onMenuClick={handleMobileOpen} />
      <LeftDrawer mobileOpen={mobileOpen} onMobileClose={handleMobileClose} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          backgroundColor: '#f7f7f9',
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
